import { Pipe, PipeTransform } from '@angular/core';

/**
 * Rounds an amount off to the nearest rupee, for display only.
 *
 *   1234.564  ->  1235
 *   1234.4    ->  1234
 *   -1234.5   ->  -1235   (half away from zero, same rule the API uses
 *                          with MidpointRounding.AwayFromZero)
 *
 * The underlying value is never touched - form controls, request payloads and
 * whatever is stored on the server keep their decimals. Anything that is not a
 * plain number (blank, text, a code that only looks numeric) is passed through
 * unchanged.
 *
 * Usage:
 *   {{ element.Amount | roundoff }}
 *   {{ element[displayedColumn] | roundoff : displayedColumn : AmountColumns }}
 *
 * The two argument form is for the column driven tables, where a single cell
 * template renders every column: the value is only rounded when the column is
 * listed in AmountColumns, so rates, ids and dates are left alone.
 */
@Pipe({ name: 'roundoff' })
export class RoundoffPipe implements PipeTransform {

  transform(value: any, fieldName?: string, monetaryFields?: string[]): any {
    if (fieldName != null && monetaryFields != null && monetaryFields.indexOf(fieldName) === -1) {
      return value;
    }

    let numeric: number;
    if (typeof value === 'number') {
      numeric = value;
    } else {
      if (value === null || value === undefined) {
        return value;
      }
      const raw = String(value).replace(/,/g, '').trim();
      if (!/^-?\d+(\.\d+)?$/.test(raw)) {
        return value;
      }
      numeric = parseFloat(raw);
    }

    if (isNaN(numeric) || !isFinite(numeric)) {
      return value;
    }

    return String(numeric < 0 ? -Math.round(-numeric) : Math.round(numeric));
  }
}
